<template>
    <div class="custom-modal show-custom-modal" @click="closeModal()">
        <div class="custom-modal-window" @click.stop>

            <div class="btn-close" v-if="fetcher.initialized" :class="{ 'btn-white' : clinic.locations.length > 0 || clinic.portrait }" @click="closeModal()"></div>

            <div class="custom-modal-body">

                <div :class="{ 'd-none' : fetcher.initialized }">
                    <div class="container-fluid">
                        <div class="placeholder-glow w-100">
                            <span class="placeholder bg-info col-24 mb-9 rounded-2" style="height: 34px;"></span>
                            <span class="placeholder bg-info col-24 mb-9 rounded-2" style="height: 110px;"></span>
                            <span class="placeholder bg-info col-24 mb-9 rounded-2" style="height: 110px;"></span>
                            <span class="placeholder bg-info col-24 mb-9 rounded-2" style="height: 110px;"></span>
                        </div>
                    </div>
                </div>

                <div v-if="fetcher.initialized">

                    <div class="presentation-slider" v-if="clinic.locations.length > 0">

                        <flickity ref="flickity" :options="flickityOptions">

                            <div class="carousel-cell" v-for="image in clinic.locations">
                                <img :src="imageUrl(image)">
                            </div>

                        </flickity>

                        <img :src="clinic.portrait.thumb_url" class="portrait" v-if="clinic.portrait" /><!-- !clinic.checkbox_multiple_clinics-->

                    </div>

                    <div class="presentation-slider" v-if="clinic.locations.length == 0">

                        <div class="carousel-cell">
                            <img src="/images/pt.jpg" loading="lazy" v-if="clinic.checkbox_60min === '1'">
                            <img src="/images/card/clinic-default-cover.jpg" loading="lazy" v-else>
                        </div>

                        <img :src="clinic.portrait.thumb_url" class="portrait" v-if="clinic.portrait" /><!-- !clinic.checkbox_multiple_clinics-->

                    </div>

                    <div class="container-fluid">

                        <div v-if="!clinic.checkbox_multiple_clinics">
                            <h1 class="mb-1">{{ clinic.card_name_person }}</h1>
                            <div class="clinic-name mb-2">{{ clinic.card_name_clinic }}</div>
                        </div>

                        <!-- clinic.checkbox_multiple_clinics-->
                        <h1 class="mb-1" v-if="clinic.checkbox_multiple_clinics">{{ clinic.card_name_clinic }}</h1>

                        <div class="d-flex align-items-center mb-4" style="font-size: 18px;" v-if="clinic.survey_count > 2 && clinic.show_survey_score === 1">
                            <img src="/images/card/review-heart.svg" style="width: 20px; margin-right: 8px;"> <span style="font-weight:500;" class="text-darker me-1">{{ clinic.survey_score}}</span> <span style="color:#999;"> ({{ clinic.survey_count}} st)</span>
                        </div>

                        <p class="mb-0" style="white-space: pre-wrap;" v-if="clinic.booking_presentation">{{ clinic.booking_presentation }}</p>

                        <div class="mt-8">
                            <h2 class="mb-3">Boka tid</h2>

                            <div class="mb-8" v-if="showCardInactiveMessage == true">

                                <p class="mb-3">Du har inga aktiva klippkort.</p>

                                <router-link class="btn btn-primary" :to="linkTo('/shop')" @click="matomoTrackEvent('Shop', 'Link', 'Clinic')">Köp klippkort</router-link>

                            </div>

                            <div v-if="app_version === 'customer_card' || (app_version === 'company_card' && (subscription_status.status === 'active' || subscription_status.status === 'ending'))">

                                <!-- Has booking times -->
                                <div v-if="clinic.has_booking_system && modalClinicDurations.length > 0" class="mb-4">
                                    <booking-view-times
                                        mode="single"
                                        :modal-clinic-id="clinic.id"
                                        :modal-clinic-durations="modalClinicDurations"
                                    />

                                    <div class="pt-2">
                                        <span class="d-inline-block me-2" >Öppna hela kalendern:</span>
                                        <a style="font-weight:600;"
                                           class="d-inline-block me-2"
                                           target="_blank"
                                           :href="clinic.booking_link"
                                           @click="matomoTrackEvent('Booking', 'Book', 'Boka 25 min')"
                                           v-if="clinic.booking_link && clinic.checkbox_25min === '1' && durations.indexOf(25) !== -1"
                                        >
                                            <span v-if="app_version === 'company_card'">Öppna</span>
                                            <span v-else>25 min</span>
                                        </a>
                                        <a style="font-weight:600;"
                                           class="d-inline-block me-2"
                                           target="_blank"
                                           :href="clinic.booking_link_2"
                                           @click="matomoTrackEvent('Booking', 'Book', 'Boka 40 min')"
                                           v-if="clinic.booking_link_2 && clinic.checkbox_40min === '1' && durations.indexOf(40) !== -1"
                                        >
                                            <span v-if="app_version === 'company_card'">Öppna</span>
                                            <span v-else>40 min</span>
                                        </a>
                                        <a style="font-weight:600;"
                                           class="d-inline-block me-2"
                                           target="_blank"
                                           :href="clinic.booking_link_3"
                                           @click="matomoTrackEvent('Booking', 'Book', 'Boka 50 min')"
                                           v-if="clinic.booking_link_3 && clinic.checkbox_50min === '1' && durations.indexOf(50) !== -1"
                                        >
                                            <span v-if="app_version === 'company_card'">Öppna</span>
                                            <span v-else>50 min</span>
                                        </a>
                                        <a style="font-weight:600;"
                                           class="d-inline-block me-2"
                                           target="_blank"
                                           :href="clinic.booking_link_60"
                                           @click="matomoTrackEvent('Booking', 'Book', 'Boka 60 min')"
                                           v-if="clinic.booking_link_60 && clinic.checkbox_60min === '1' && durations.indexOf(60) !== -1"
                                        >
                                            <span>Öppna</span>
                                        </a>
                                    </div>

                                </div>

                                <!-- With booking system but without times -->
                                <div v-if="!clinic.has_booking_system">
                                    <a class="btn btn-primary btn-sm mb-3 me-3"
                                       target="_blank"
                                       :href="clinic.booking_link"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka 25 min')"
                                       v-if="clinic.booking_link && clinic.checkbox_25min === '1' && durations.indexOf(25) !== -1"
                                    >
                                        <span v-if="app_version === 'company_card'">Boka tid</span>
                                        <span v-else>Boka 25 min</span>
                                    </a>
                                    <a class="btn btn-primary btn-sm mb-3 me-3"
                                       target="_blank"
                                       :href="clinic.booking_link_2"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka 40 min')"
                                       v-if="clinic.booking_link_2 && clinic.checkbox_40min === '1' && durations.indexOf(40) !== -1"
                                    >
                                        <span v-if="app_version === 'company_card'">Boka tid</span>
                                        <span v-else>Boka 40 min</span>
                                    </a>
                                    <a class="btn btn-primary btn-sm mb-3 me-3"
                                       target="_blank"
                                       :href="clinic.booking_link_3"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka 50 min')"
                                       v-if="clinic.booking_link_3 && clinic.checkbox_50min === '1' && durations.indexOf(50) !== -1"
                                    >
                                        <span v-if="app_version === 'company_card'">Boka tid</span>
                                        <span v-else>Boka 50 min</span>
                                    </a>
                                    <a class="btn btn-primary btn-sm mb-3 me-3"
                                       target="_blank"
                                       :href="clinic.booking_link_60"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka 60 min')"
                                       v-if="clinic.booking_link_60 && clinic.checkbox_60min === '1' && durations.indexOf(60) !== -1"
                                    >
                                        <span>Boka tid</span>
                                    </a>
                                </div>

                                <!-- Booking buttons for contact ways, if missing booking system -->
                                <div v-if="showCardInactiveMessage == false">

                                    <a class="btn btn-primary btn-sm mb-3 me-3 ps-3"
                                       :href="bookingSmsText"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka via SMS')"
                                       v-if="clinic.checkbox_show_booking_button_sms === '1' && clinic.public_phone"
                                    >
                                        <img src="/images/card/icon-booking-sms.svg?ver=1" class="btn-icon"><span>Boka via SMS</span>
                                    </a>

                                    <a class="btn btn-primary btn-sm mb-3 me-3 ps-3"
                                       :href="'tel:'+clinic.public_phone"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka via telefon')"
                                       v-if="clinic.checkbox_show_booking_button_phone === '1' && clinic.public_phone"
                                    >
                                        <img src="/images/card/icon-booking-phone.svg?ver=1" class="btn-icon"><span>Boka via telefon</span>
                                    </a>

                                    <a class="btn btn-primary btn-sm mb-3 me-3 ps-3"
                                       :href="bookingMailText"
                                       @click="matomoTrackEvent('Booking', 'Book', 'Boka via e-post')"
                                       v-if="clinic.checkbox_show_booking_button_email === '1' && clinic.public_email"
                                    >
                                        <img src="/images/card/icon-booking-email.svg" class="btn-icon"><span>Boka via e-post</span>
                                    </a>

                                </div>

                                <!-- INfo about booking system, if no booking system -->
                                <div v-if="clinic.checkbox_60min !== '1'">
                                    <div class="pt-2" v-if="!clinic.booking_link && !clinic.booking_link_2 && !clinic.booking_link_3 && !hasPractitioners">
                                        <span>Massören erbjuder följande behandlingslängder:</span>

                                        <div class="mb-4 pt-1">
                                            <span style="display:inline-block; padding:4px 8px; margin-right: 8px; border:1px solid #ccc; border-radius: 6px; color:#333;" v-if="clinic.checkbox_25min === '1'">25 min</span>
                                            <span style="display:inline-block; padding:4px 8px; margin-right: 8px; border:1px solid #ccc; border-radius: 6px; color:#333;" v-if="clinic.checkbox_40min === '1'">40 min</span>
                                            <span style="display:inline-block; padding:4px 8px; margin-right: 8px; border:1px solid #ccc; border-radius: 6px; color:#333;" v-if="clinic.checkbox_50min === '1'">50 min</span>
                                            <span style="display:inline-block; padding:4px 8px; margin-right: 8px; border:1px solid #ccc; border-radius: 6px; color:#333;" v-if="clinic.checkbox_60min === '1'">60 min</span>
                                        </div>
                                    </div>
                                </div>

                                <p v-if="clinic.booking_info && showCardInactiveMessage != true" v-html="clinic.booking_info"></p>

                            </div>

                            <div v-if="app_version === 'company_card'">

                                <div class="button-message" v-if="subscription_status.status === 'ending'">
                                    <div class="arrow"></div>
                                    Boka fram till och med <b>{{ subscription_status.date }}</b>.
                                    Därefter slutar din arbetsgivare ge ersättning för behandlingen.
                                </div>

                                <div class="button-message" v-if="subscription_status.status === 'ended'">
                                    Du kan inte längre boka massage, eftersom din arbetsgivare sagt upp avtalet.
                                </div>

                                <div class="button-message" v-if="subscription_status.status === 'pending'">
                                    Du kan börja boka massage från <b>{{ subscription_status.date }}</b>. Välkommen tillbaka!
                                </div>

                            </div>

                        </div>

                        <div class="mb-6" v-if="hasPractitioners">

                            <h2 class="mb-0 mt-8" v-if="clinic.booking_link || clinic.booking_link_2|| clinic.booking_link_3">Massörer</h2>

                            <div class="border-top py-6 py-sm-8"
                                 :class="{
                                    'border-bottom': (index +1) === clinic.practitioners.length,
                                    'mt-4': index === 0
                                 }"
                                 v-for="(practitioner, index) in clinic.practitioners"
                                 :key="`practitioner${practitioner.id}`"
                            >
                                <div class="row">
                                    <div class="col-8 col-sm-4" v-if="practitioner.portrait || practitioner.booking_link_60">
                                        <div class="d-grid gap-4">
                                            <img class="w-100 rounded-circle" :src="practitioner.portrait.thumb_url" v-if="practitioner.portrait" />

                                            <a target="_blank" :href="practitioner.booking_link_60" class="btn btn-primary btn-sm" v-if="practitioner.booking_link_60">Boka tid</a>

                                        </div>
                                    </div>
                                    <div class="col">
                                        <h3 class="text-darker">{{ practitioner.name }}</h3>
                                        <p>{{ practitioner.presentation }}</p>
                                    </div>
                                </div>
                                <div class="row pt-4">
                                    <div class="col">
                                        <a target="_blank" :href="practitioner.booking_link_25" class="btn btn-primary  btn-sm mb-3 me-3" v-if="practitioner.booking_link_25">Boka 25 min</a>

                                        <a target="_blank" :href="practitioner.booking_link_40" class="btn btn-primary  btn-sm mb-3 me-3" v-if="practitioner.booking_link_40">Boka 40 min</a>

                                        <a target="_blank" :href="practitioner.booking_link_50" class="btn btn-primary  btn-sm mb-3 me-3" v-if="practitioner.booking_link_50">Boka 50 min</a>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <p class="mt-2 mb-8" v-if="showCardInactiveMessage != true">
                            <i style="color:#666;">
                                Mottagningens egna avbokningsregler gäller.
                            </i>
                        </p>

                        <div class="mb-10" v-if="clinic.booking_directions">

                            <h2>Hitta hit</h2>
                            <p v-html="clinic.booking_directions"></p>

                        </div>

                        <div class="mb-10" v-if="clinic.booking_instructions">

                            <h2>Övrig information</h2>
                            <p v-html="clinic.booking_instructions"></p>

                        </div>

                        <div class="mb-10">
                            <h2>Kontaktuppgifter</h2>
                            <p>
                                <span v-if="!clinic.checkbox_multiple_clinics">{{ clinic.card_name_person }}<br></span>
                                <span v-if="clinic.public_phone"><a :href="'tel:'+clinic.public_phone">{{ clinic.public_phone }}</a><br></span>
                                <span v-if="clinic.public_email"><a :href="'mailto:'+clinic.public_email">{{ clinic.public_email }}</a></span>
                            </p>
                        </div>

                        <div class="mb-10">
                            <h2>Adress</h2>
                            <p>
                                <address class="mb-0">
                                    <span v-if="clinic.card_name_clinic">{{ clinic.card_name_clinic }}<br></span>
                                    <span v-if="clinic.address.co">{{ clinic.address.co }},<br></span>
                                    <span v-if="clinic.address.street">{{ clinic.address.street }},<br></span>
                                    <span v-if="clinic.address.city">{{ clinic.address.zip }}</span> <span v-if="clinic.address.city">{{ clinic.address.city }}</span>
                                </address>
                                <a :href="'https://maps.google.com/?q='+mapLinkQuery" class="clinic-map-link" target="_blank">Öppna i Google maps</a><br>
                                <a :href="'https://maps.apple.com/maps?q='+mapLinkQuery" class="clinic-map-link apple" target="_blank">Öppna i Kartor</a>
                            </p>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>

import Flickity from 'vue-flickity'
import BookingViewTimes from './booking-view-times.vue'

import modaler from '../../../shared/mixins/modaler'
import poster from '../../../shared/mixins/poster'
import fetcher from '../../../shared/mixins/fetcher'
import { mapState } from 'pinia'
import { useCardsStore } from '../../stores/cardsStore'

export default {

    components: {
        Flickity,
        BookingViewTimes
    },

    mixins: [
        modaler,
        poster,
        fetcher
    ],

    data () {
        return {
            clinic: null,
            durations: [],
            fetcher: {
                autoFill: [
                    'clinic',
                    'durations'
                ]
            },
            clinicMap: {
                map: null,
                markers: []
            },
            flickityOptions: {
                prevNextButtons: false,
                wrapAround: true,
                lazyLoad: true
            }
        }
    },

    mounted () {

    },

    computed: {
        ...mapState(useCardsStore, {
            active_cards: state => state.active_cards
        }),
        fetcherUrl () {
            return '/clinics/' + this.$route.params.clinic
        },
        bookingLinksVisible () {
            if (!(this.clinic.booking_link && this.clinic.checkbox_25min === '1' && this.durations.indexOf(25) !== -1) && !(this.clinic.booking_link_2 && this.clinic.checkbox_40min === '1' && this.durations.indexOf(40) !== -1) && !(this.clinic.booking_link_3 && this.clinic.checkbox_50min === '1' && this.durations.indexOf(50) !== -1) && !(this.clinic.booking_link_60 && this.clinic.checkbox_60min === '1' && this.durations.indexOf(60) !== -1)) {
                return false
            }
            return true
        },
        showCardInactiveMessage () {
            if (this.app_version === 'customer_card' && this.active_cards.length === 0) {
                return true
            }
            return false
        },
        mapLinkQuery () {
            return this.clinic.address.street + ' ' + this.clinic.address.zip + ' ' + this.clinic.address.city
        },
        singleDurationText () {
            if (this.durations.length == 1) {
                return 'Behandlingslängd ' + this.durations[0] + ' minuter. '
            }
            return ''
        },
        hasPractitioners () {
            return this.clinic.practitioners.length > 0
        },
        bookingMailText () {
            if (this.clinic.checkbox_60min === '1') {
                return 'mailto:' + this.clinic.public_email + '?subject=Jag vill boka personlig träning via Hälsoresurs&body=Hej. Jag vill boka personlig träning via Hälsoresurs. När finns det lediga tider? Tack!'
            }

            return 'mailto:' + this.clinic.public_email + '?subject=Jag vill boka massage via Hälsoresurs&body=Hej. Jag vill boka massage via Hälsoresurs. ' + this.singleDurationText + 'När finns det lediga tider? Tack!'
        },

        bookingSmsText () {
            if (this.clinic.checkbox_60min === '1') {
                return 'sms:' + this.clinic.public_phone + '?body=Hej. Jag vill boka personlig träning via Hälsoresurs. När finns det lediga tider? Tack!'
            }

            return 'sms:' + this.clinic.public_phone + '?body=Hej. Jag vill boka massage via Hälsoresurs. ' + this.singleDurationText + 'När finns det lediga tider? Tack!'
        },

        nextBookingTime () {
            if (this.clinic.booking_times.length === 0) {
                return null
            }

            return this.clinic.booking_times[0].starts_at
        },

        modalClinicDurations () {
            const durations = []
            if (this.clinic.checkbox_25min === '1' && this.durations.indexOf(25) !== -1) {
                durations.push(25)
            }
            if (this.clinic.checkbox_40min === '1' && this.durations.indexOf(40) !== -1) {
                durations.push(40)
            }
            if (this.clinic.checkbox_50min === '1' && this.durations.indexOf(50) !== -1) {
                durations.push(50)
            }
            if (this.clinic.checkbox_60min === '1' && this.durations.indexOf(60) !== -1) {
                durations.push(60)
            }

            return durations
        }
    },

    methods: {

        fetcherSuccess () {

        },

        rawUrl (location) {
            return '/storage/clinic-presentation/' + location.name + '.jpg'
        },

        imageUrl (location) {
            // edited_url already carries its own cache-busting query param.
            if (location.edited_url) {
                return location.edited_url
            }
            return this.rawUrl(location)
        },

        closeModal () {
            this.$router.push({ name: this.$route.meta.closeTo })
            jQuery('html').removeClass('modal-open')
        }

    }
}
</script>

<style>

</style>
